export default "__VITE_ASSET__BGK60y$___"